<!-- #3 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Inbound Orders List
      </div>
      <v-spacer> </v-spacer>

      <v-btn
        small
        color="primary"
        class="mr-6"
        @click="$router.push('/add-inbound-order')"
        >Add Inbound Order</v-btn
      >
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="_headers"
      :items="list"
      :loading="listLoader"
      :options.sync="options"
      :server-items-length="total"
      class="elevation-1 custom-icon-size mt-7"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <template>
          <v-form>
            <v-row class="custom-row pl-5 pr-5">
              <v-col cols="12" sm="3" v-if="userCategory.user_category === 3">
                <v-autocomplete
                  outlined
                  v-model="client"
                  :items="clients"
                  dense
                  chips
                  small-chips
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  @input="fetchVendor(client)"
                  @focus="fetchClientList"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  outlined
                  v-model="purchase_order_code"
                  label="Inbound Order Code"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  outlined
                  v-model="vendor_code"
                  :items="vendors"
                  dense
                  chips
                  small-chips
                  item-text="vendor_name"
                  item-value="vendor_code"
                  label="Vendor"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  outlined
                  v-model="vendorInvoiceNumber"
                  label="Vendor Invoice Number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  outlined
                  v-model="selectedStatus"
                  :items="statusList"
                  dense
                  chips
                  small-chips
                  label="Status"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  outlined
                  v-model="additional_reference_number"
                  label="Additional Reference Number"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                class="pr-6"
                :class="[userCategory.user_category === 1 ? 'offset-md-3' : '']"
              >
                <v-btn
                  color="white v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                  class="ml-4"
                  @click="clearAll"
                  style="float: right"
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
                <v-btn
                  color="primary"
                  class="v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary mr-2"
                  @click="sync"
                  :loading="syncButton"
                  style="float: right"
                  v-if="
                    (client || userCategory.user_category == 1) &&
                    checkPermission('app_ecom_vendors:fulfillment_inbound_sync')
                  "
                  >Sync</v-btn
                >
                <v-btn
                  class="info px-1 mr-3"
                  color="primary"
                  @click="downloadInboundOrder"
                  style="float: right"
                  v-if="
                    checkPermission(
                      'app_ecom_vendors:fulfillment_inbound_download'
                    )
                  "
                  >Download</v-btn
                >
              </v-col>
            </v-row>
            <v-divider class="mt-2 mb-2"></v-divider>
          </v-form>
        </template>
      </template>
      <template v-slot:[`item.client`]="{ item }">
        <span v-if="item.client">{{ item.client }}</span>
        <span v-else>--</span>
      </template>

      <template v-slot:[`item.order_quantity`]="{ item }">
        {{ getData(item, "order_quantity") }}
      </template>
      <template v-slot:[`item.rejected_quantity`]="{ item }">
        {{ getData(item, "rejected_quantity") }} </template
      ><template v-slot:[`item.received_quantity`]="{ item }">
        {{ getData(item, "received_quantity") }}
      </template>
      <template v-slot:[`item.po_items_total`]="{ item }">
        {{ getData(item, "po_items_total") }}
      </template>

      <template v-slot:[`item.po_status`]="{ item }">
        <span v-if="item.click_created == 1"
          ><a @click="openError(item)">{{ item.po_status }}</a></span
        >
        <span v-else>{{ item.po_status }}</span>
      </template>
      <template v-slot:[`item.created`]="{ item }">
        <span v-if="item.uae_time_created">
          {{
            item.uae_time_created
              | localMomentNew
              | moment("DD MMM, YYYY hh:mm A")
          }}</span
        >
        <span v-else>--</span>
      </template>
      <template v-slot:[`item.updated`]="{ item }">
        <span v-if="item.uae_time_updated">
          {{
            item.uae_time_updated
              | localMomentNew
              | moment("DD MMM, YYYY hh:mm A")
          }}</span
        >
        <span v-else>--</span>
      </template>
      <template v-slot:[`item.delivery_date`]="{ item }">
        <span v-if="item.delivery_date">{{
          item.delivery_date | localMomentNew | moment("DD MMM, YYYY ")
        }}</span>
        <span v-else>--</span>
      </template>
      <template v-slot:item.action="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="open(item)"
            >
              mdi-eye-outline
            </v-icon>
          </template>
          <span>Order details</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="openGrn(item)"
            >
              mdi-cart-check
            </v-icon>
          </template>
          <span>GRNs orders</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template
            v-slot:activator="{ on, attrs }"
            v-if="
              checkPermission(
                'app_ecom_vendors:fulfillment_inbound_items_download'
              )
            "
          >
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              :loading="downloaderRow"
              @click="downloadRow(item.id)"
            >
              mdi-download
            </v-icon>
          </template>
          <span>Download</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialogItem"
      max-width="650px"
      @keydown.esc="dialogItem = false"
      scrollable
    >
      <v-card>
        <v-card-title>
          <span class="headline"> Order Details</span>
          <v-spacer></v-spacer>
          <v-icon
            @click="
              dialogItem = false;
              tableDataItems = [];
            "
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <v-data-table
            :headers="headersItems"
            :items="tableDataItems"
            :expand="expand"
            :options.sync="optionsDetails"
            :server-items-length="totalDetails"
            item-key="id"
            :footer-props="{
              itemsPerPageOptions: [25, 50, 100, 250],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog"
      max-width="650px"
      @keydown.esc="dialog = false"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title>
          <span class="headline"
            >Inbound Order - {{ openGrnItem.purchase_order_code }} | ({{
              openGrnItem.client
            }})</span
          >
          <v-spacer></v-spacer>
          <v-icon
            @click="
              dialog = false;
              tableData = [];
            "
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div class="loader-wrapper" v-if="isTableloading">
            <div class="loader"></div>
          </div>
          <v-data-table
            :headers="expendHeaders"
            :items="tableData"
            item-key="id"
            @click:row="toggleRowExpansion"
            class="elevation-1 custom-padding"
            hide-default-footer
            disable-pagination
            :single-expand="true"
            :expanded.sync="tableData"
          >
            <template v-slot:item.GRN#="{ item }" class="pl-0 pr-0">
              <div>
                <span class="spanClass" style="cursor: pointer"
                  ><b>{{ item.GRN }}</b></span
                >

                <template class="mt-2">
                  <tr v-if="item.subTableData.length > 0">
                    <td :colspan="expendHeaders.length">
                      <v-data-table
                        :headers="subTableHeaders"
                        :items="item.subTableData"
                        hide-default-footer
                        disable-pagination
                        class="mt-2"
                        style="
                          border: 1px solid lightgray;
                          border-bottom: none;
                          width: 600px;
                        "
                      >
                        <template v-slot:item.subGRN#="{ item }">
                          {{ item }}
                        </template>

                        <template v-slot:item.status>
                          {{ subTableDataStatus }}
                        </template>
                        <template v-slot:item.created>
                          {{ subTableDataCreated | moment("DD MMM, YYYY") }}
                        </template>
                      </v-data-table>
                    </td>
                  </tr>
                </template>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="openMessage"
      max-width="650px"
      close-delay="ma-5"
      scrollable
      @keydown.esc="
        openMessage = false;
        detailsData = [];
      "
    >
      <v-card>
        <v-card-title
          >Message
          <v-spacer></v-spacer>
          <v-icon
            @click="
              openMessage = false;
              detailsData = [];
            "
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="">
          <v-data-table
            :headers="detailsHeaders"
            :items="detailsData"
            class="elevation-1 mt-7"
            :items-per-page="25"
            :options.sync="optionsDetails"
            :server-items-length="totals"
            :footer-props="{
              itemsPerPageOptions: [25, 50, 100, 250],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
            <template v-slot:[`item.errors`]="{ item }">
              {{ item.warnings }}
              <span v-if="item.errors !== null">
                <ul v-if="item.errors.length > 0">
                  <li v-for="(item, i) of item.errors" :key="i">
                    {{ item.description }}
                  </li>
                </ul>
                <span v-else> -- </span>
              </span>
            </template>
            <template v-slot:[`item.warnings`]="{ item }">
              <span v-if="item.warnings !== null">
                {{ item.warnings }}
              </span>
              <span v-else> -- </span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="loader-wrapper" v-if="isloading">
      <div class="loader"></div>
    </div>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters(["userCategory"]),
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
    _headers() {
      return this.headers.filter((i) => {
        return this.userCategory.user_category !== 3
          ? i.value !== "client"
          : true;
      });
    },
  },
  data: () => ({
    additional_reference_number: null,
    openMessage: false,
    detailsData: [],
    tableDetailsItems: [],
    vendors: [],
    expandedRows: [],
    openGrnItem: {},
    totalDetails: 0,
    optionsDetails: {
      page: 1,
      itemsPerPage: 25,
      sortDesc: [false],
    },
    dialogItem: false,
    listloader: false,
    iconLoader: false,
    isloading: false,
    subTableDataStatus: null,
    subTableDataCreated: null,
    headersItems: [
      {
        text: "Category",
        value: "category",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Sku Code",
        value: "item_sku_code",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Quantity",
        value: "order_quantity",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Pending Qty",
        value: "pending_quantity",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Received Qty",
        value: "received_quantity",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Rejected Qty",
        value: "rejected_quantity",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Total",
        value: "sub_total",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
    detailsHeaders: [
      {
        text: "Error",
        value: "errors",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Warning",
        value: "warnings",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
    headers: [
      {
        text: "Client",
        value: "client",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Inbound order code",
        value: "purchase_order_code",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Vendor Name",
        value: "vendor_name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Vendor Invoice Number",
        value: "vendor_invoice_number",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Additional Ref. Number",
        value: "additional_reference_number",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Currency Code",
        value: "currency_code",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Client Ordered Quantity",
        value: "order_quantity",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Quantity received",
        value: "received_quantity",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Rejected quantity",
        value: "rejected_quantity",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Total",
        value: "po_items_total",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Delivery Date",
        value: "delivery_date",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Status",
        value: "po_status",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Created At",
        value: "created",
        class: "body-1 font-weight-bold",
        width: "200px",
        sortable: false,
      },
      {
        text: "Updated At",
        value: "updated",
        class: "body-1 font-weight-bold",
        width: "200px",
        sortable: false,
      },

      {
        text: "Action",
        value: "action",
        class: "body-1 font-weight-bold",
        width: "200px",
        sortable: false,
      },
    ],
    carriers: [],
    isTableloading: false,
    itemCalled: false,
    sku: null,
    client: null,
    loading: false,
    list: [],
    listLoader: false,
    filtersArr: {},
    clients: [],
    total: 0,
    options: {},
    categories: [],
    categoryLoader: false,
    category: "",
    downloader: false,
    dialog: false,
    file: null,
    selectedClient: "",
    fileLoader: false,
    statusList: [],
    vendorInvoiceNumber: "",
    selectedStatus: "",
    headersArr: [
      { text: "ID", value: "id" },
      { text: "SKU", value: "sku" },
      { text: "Quantity", value: "quantity" },
      { text: "Pending Quantity", value: "pending_quantity" },
      { text: "Rejected Quantity", value: "rejected_quantity" },
    ],
    subTableHeaders: [
      { text: "SKU", value: "sku", align: "center", sortable: false },
      { text: "Status", value: "status", align: "center", sortable: false },
      {
        text: "Boe Number",
        value: "boe_number",
        align: "center",
        sortable: false,
      },
      {
        text: "Batch Code",
        value: "batch_code",
        align: "center",
        sortable: false,
      },
      { text: "Coo", value: "coo", align: "center", sortable: false },

      {
        text: "Created at",
        value: "created",
        align: "center",
        sortable: false,
      },
      {
        text: "Received Quantity",
        value: "quantity",
        align: "center",
        sortable: false,
      },
      {
        text: "Pending Quantity",
        value: "pending_quantity",
        align: "center",
        sortable: false,
      },
      {
        text: "Rejected Quantity",
        value: "rejected_quantity",
        align: "center",
        sortable: false,
      },
    ],
    tableData: [],
    totals: 0,
    syncButton: false,
    expand: [],
    purchase_order_code: "",
    vendor_code: "",
    expanded: [],
    tableDataItems: [],
    selectedGrn: "",
    expandedRow: null,
    itemFound: {},
    downloaderRow: false,
    expendHeaders: [
      {
        text: "GRN #",
        align: "start",
        value: "GRN#",
        sortable: false,
        width: "600",
      },
    ],
    subheader: [
      {
        text: "Sku",
        value: "sku",
        width: "200",
      },
      {
        text: "Quantity",
        value: "quantity",
        width: "100",
      },
      {
        text: "Pending Quantity",
        value: "pending_quantity",
        width: "100",
      },
      {
        text: "Rejected Quantity",
        value: "rejected_quantity",
        width: "100",
      },
    ],
  }),

  created() {
    this.fetchClientList();
    if (this.userCategory.user_category == 1) {
      this.fetchVendor();
    }
  },
  watch: {
    options: {
      handler() {
        this.fetchList();
      },
      deep: true,
    },
    optionsDetails: {
      handler() {
        if (this.optionsDetails.page != 1) this.open();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "snackBar",
      "getInboundOrderList",
      "fetchClient",
      "getVendorsList",
      "getItemDetails",
      "getGrnDetails",
      "getVendorsLists",
      "getGrnOrderDetails",
      "getMessageRes",
      "syncInboundOrder",
      "downloadInboundOrderList",
      "downloadInboudOrderRow",
    ]),
    downloadRow(id) {
      this.downloaderRow = true;
      this.downloadInboudOrderRow(id)
        .then((res) => {
          this.fileDownload(res);
          this.downloaderRow = false;
          this.snackBar({
            color: "success",
            message: "file download successfully",
          });
        })
        .catch(() => {
          this.downloaderRow = false;
        });
    },
    downloadInboundOrder() {
      this.downloader = true;
      this.allFilters();
      let data = {
        ...this.options,
        ...this.filtersArr,
      };
      this.downloadInboundOrderList(data)
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
    async openError(item) {
      this.item = item;
      if (this.item == undefined) return;
      let data = {
        excel_id: this.item.excel_upload,
      };
      await this.getMessageRes({ ...data, ...this.optionsDetails }).then(
        (res) => {
          this.detailsData = res.data.records;
          this.totals = res.data.total;
          this.openMessage = true;
        }
      );
    },
    async toggleRowExpansion(item) {
      this.tableData.map((e) => {
        e.subTableData = [];
      });
      item.clickable = !item.clickable;
      if (item.clickable) {
        await this.fetchSubTableData(item);
      } else {
        item.subTableData = [];
      }
    },
    async fetchSubTableData(item) {
      this.subTableDataStatus = null;
      this.subTableDataCreated = null;
      this.isTableloading = true;
      let data = {
        grn_number: item.GRN,
        purchase_order_code: this.selectedGrn,
      };
      await new Promise(() => {
        this.getGrnOrderDetails(data)
          .then((res) => {
            item.subTableData = res.data.items;
            this.subTableDataStatus = res.data.status;
            this.subTableDataCreated = res.data.created;
            this.isTableloading = false;
          })
          .catch(() => {
            this.isTableloading = false;
          });
      });
    },
    getData(e, type) {
      let searchKey = e.id;
      if (this.tableDetailsItems.length > 0) {
        let result = this.tableDetailsItems.find(
          (item) => item.oms_po_id === searchKey
        );
        if (result !== undefined && result !== null && result !== "") {
          if (type == "order_quantity") {
            return result.order_quantity;
          } else if (type == "received_quantity") {
            return result.received_quantity;
          } else if (type == "po_items_total") {
            return this.changeFormat(result.po_items_total);
          } else if (type == "rejected_quantity") {
            return result.rejected_quantity;
          } else {
            return "--";
          }
        } else {
          return "--";
        }
      } else {
        return "--";
      }
    },
    async open(item) {
      let id;
      if (item == undefined) {
        id = this.itemFound.id;
      } else {
        id = item.id;
        this.itemCalled = true;
        this.itemFound = item;
      }
      let data = {
        po_id: id,
        options: this.optionsDetails,
      };
      await this.getItemDetails(data).then((res) => {
        this.tableDataItems = res.data.data.records;
        this.dialogItem = true;
        this.totalDetails = res.data.data.total;
      });
    },
    openGrn(item) {
      this.openGrnItem = item;
      this.isloading = true;
      this.selectedGrn = item.id;
      let data = {
        purchase_order_code: item.id,
      };
      this.getGrnDetails(data)
        .then((responseData) => {
          responseData.data.map((e, i) => {
            let obj = { id: i, GRN: e, clickable: false, subTableData: [] };
            this.tableData.push(obj);
          });
          this.dialog = true;
          this.isloading = false;
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    download() {
      this.downloader = true;
      this.allFilters();
      this.downloadSkuList({ ...this.filtersArr }).then((res) => {
        this.fileDownload(res);
        this.downloader = false;
      });
    },
    clearDateInput(from) {
      if (from == "to_date") {
        this.to_date = null;
      } else {
        this.from_date = null;
      }
    },
    clearAll() {
      this.filtersArr = {};
      this.vendor_code = null;
      this.client = null;
      this.vendorInvoiceNumber = "";
      this.selectedStatus = "";
      this.purchase_order_code = null;
      this.additional_reference_number = null;
      this.fetchList();
    },
    callFunction(user_id) {
      this.getVendorsLists(user_id)
        .then((res) => {
          this.vendorLoader = false;
          this.vendors = res.data;
        })
        .catch(() => {
          this.vendorLoader = false;
        });
    },
    fetchVendor(id) {
      if (id !== null && id !== undefined && id !== "") {
        this.vendorLoader = true;
        if (this.userCategory.user_category == 3) {
          this.callFunction(id);
        }
      } else {
        if (this.userCategory.user_category == 1) {
          this.callFunction(this.$store.getters.user.id);
        }
      }
    },
    fetchClientList() {
      if (this.clients.length) return;

      if (this.clients.length === 0 && this.userCategory.user_category === 3) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "fulfillment,fulfillment_wid_last_mile",
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    allFilters() {
      this.clientsLoader = true;
      let obj = {
        client_id: this.client,
        vendor_code: this.vendor_code,
        purchase_order_code: this.purchase_order_code,
        po_status: this.selectedStatus,
        vendor_invoice_number: this.vendorInvoiceNumber,
        additional_reference_number: this.additional_reference_number,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    listPage() {
      this.$router.push({
        name: "skuStatusList",
        params: {
          type: "sku_mapping",
        },
      });
    },

    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.getInboundOrderList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.listLoader = false;
          this.list = res.data.data.records;
          this.total = res.data.data.total;
          this.tableDetailsItems = res.data.data.records2;
          this.statusList = res.data.data.status_choices;
        })
        .catch(() => {
          this.listLoader = false;
        });
    },
    fetchList() {
      this.list = [];
      this.listLoader = true;
      this.getInboundOrderList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.listLoader = false;
          this.list = res.data.data.records;
          this.total = res.data.data.total;
          this.tableDetailsItems = res.data.data.records2;
          this.statusList = res.data.data.status_choices;
        })
        .catch(() => {
          this.listLoader = false;
        });
    },
    upload() {
      if (!this.$refs.form.validate()) return;
      this.fileLoader = true;
      const payload = new FormData();
      payload.append("data_file", this.file, this.file.name);
      if (this.userCategory.user_category === 3) {
        payload.append("client_id", this.selectedClient.id);
      }
      this.uploadSku(payload)
        .then((res) => {
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.$refs.form.reset();
          this.dialog = false;
          this.fileLoader = false;
        })
        .catch(() => {
          this.dialog = false;
          this.$refs.form.reset();
          this.fileLoader = false;
        });
    },
    sync() {
      this.syncButton = true;
      this.syncInboundOrder(this.client)
        .then((res) => {
          this.syncButton = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.fetchList();
        })
        .catch(() => {
          this.syncButton = false;
        });
    },
  },
};
</script>
<style>
.custom-row .col-sm-2 {
  flex: 1 0 16.6666666667% !important;
  max-width: 21.666667% !important;
}
/* Styles for the loader wrapper */
.loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Ensure the loader appears on top of other content */
}

/* Styles for the loader itself */
.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite; /* Add a spinning animation */
}

/* Animation keyframes for the loader */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Styles to hide the content when the loader is active */
.loader-wrapper.active {
  display: flex;
}

.content {
  display: none;
}

.loader-wrapper.active + .content {
  display: block;
}
.v-data-table.elevation-1.custom-padding.theme--light tbody tr td.text-start {
  padding: 0 !important;
}
.spanClass {
  display: block;
  padding-left: 18px;
  padding-top: 6px;
}
</style>
